export default __webpack_public_path__ + "static/media/menu-list-settings.c33b2eaa.svg";